/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ParticipantDto } from '../models/ParticipantDto';
import type { ParticipantFilterResponseDto } from '../models/ParticipantFilterResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipantControllerService {

    /**
     * @param healthStatus
     * @param from
     * @param status
     * @param limit
     * @param name
     * @param storageType
     * @returns ParticipantFilterResponseDto OK
     * @throws ApiError
     */
    public static listParticipants(
        healthStatus?: boolean,
        from?: number,
        status?: 'COMPLETED' | 'PENDING' | 'RUNNING',
        limit?: number,
        name?: string,
        storageType?: 'Memory' | 'Postgres' | 'Shared Postgres' | 'External',
    ): CancelablePromise<ParticipantFilterResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/participants',
            query: {
                'healthStatus': healthStatus,
                'from': from,
                'status': status,
                'limit': limit,
                'name': name,
                'storageType': storageType,
            },
            errors: {
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static updateParticipant(
        requestBody: ParticipantDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/participants',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns ParticipantDto Created
     * @throws ApiError
     */
    public static createParticipant(
        requestBody: ParticipantDto,
    ): CancelablePromise<ParticipantDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/participants',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @returns ParticipantDto OK
     * @throws ApiError
     */
    public static getParticipant(
        name: string,
    ): CancelablePromise<ParticipantDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/participants/{name}',
            path: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @returns void
     * @throws ApiError
     */
    public static deleteParticipant(
        name: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/participants/{name}',
            path: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

}
